import React, { useEffect, useState } from "react";
import MateriaSelect from "./MateriaSelect";
import { useNavigate } from "react-router-dom";

function Home() {
	const navigate = useNavigate();
		const [questions, setQuestions] = useState([]);
		const [loading, setLoading] = useState(false);
		const [answers, setAnswers] = useState({});
		const [mensagem, setMensagem] = useState("");
		const [showResult, setShowResult] = useState(false);
		const [score, setScore] = useState(0);
		const [current, setCurrent] = useState(0);
		const [materia, setMateria] = useState(null);
		const token = localStorage.getItem("token");

		useEffect(() => {
			if (!token) {
				navigate("/login");
				return;
			}
			if (!materia) return;
			setQuestions([]); // Limpa questões ao trocar matéria
			setMensagem("");
			setShowResult(false);
			setScore(0);
			setCurrent(0);
			setLoading(true);
			async function fetchQuestions() {
				const res = await fetch(`/api/questions?materia=${encodeURIComponent(materia)}` , {
					headers: { Authorization: `Bearer ${token}` },
				});
				if (res.ok) {
					const data = await res.json();
					setQuestions(data);
					if (data.length === 0) {
						setMensagem("Não há questões cadastradas para esta matéria.");
					}
				} else {
					setMensagem("Erro ao carregar questões. Faça login novamente.");
				}
				setLoading(false);
			}
			fetchQuestions();
		}, [token, navigate, materia]);

		const handleSelect = (qid, idx) => {
			setAnswers({ ...answers, [qid]: idx });
		};

		const handlePrev = () => {
			setCurrent((prev) => Math.max(prev - 1, 0));
		};

		const handleNext = () => {
			setCurrent((prev) => Math.min(prev + 1, questions.length - 1));
		};

			const handleSubmit = async (e) => {
				e.preventDefault();
				let acertos = 0;
				questions.forEach(q => {
					if (answers[q.id] === q.correta) acertos++;
				});
				setScore(acertos);
				setShowResult(true);
				// Salva resultado no backend, mas não espera o retorno para mostrar resultado
				fetch("/api/results", {
					method: "POST",
					headers: {
						"Content-Type": "application/json",
						Authorization: `Bearer ${token}`,
					},
					body: JSON.stringify({ score: acertos }),
				}).then(res => {
					if (!res.ok) setMensagem("Erro ao enviar resultado.");
				});
			};

		// ...existing code...

		const handleLogout = () => {
			localStorage.removeItem("token");
			navigate("/login");
		};

								const percent = questions.length ? Math.round((score / questions.length) * 100) : 0;
								const isAprovado = percent >= 70;
									function handleMateriaSelect(materia) {
											navigate(`/${materia}`);
									}
									return <MateriaSelect onSelect={handleMateriaSelect} />;
// ...existing code...
}

export default Home;
